module.exports = __webpack_public_path__ + "img/other-icon-img2.03279639.svg";